export default "__VITE_ASSET__BDgEj$Ie__"